module.exports = __webpack_public_path__ + "img/bsgpro-fabrics-catalog.15af204d.jpg";